import { defineAction } from '~/prix'
import { z } from 'zod'
import operatorListAction from './operatorList.action.json' with { type: 'json' }
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import { operatorObject } from '../operatorObject'

export const operatorExpression = expression(operatorObject.shape)

const operatorListDefinition = defineAction({
  ...operatorListAction,

  input: z.object({
    filter: operatorExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      code: 'Código',
      citizenId: 'Cidadão',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeInactivated: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(operatorObject),
    count: z.number(),
  }),
})

export default operatorListDefinition
